// baseUrl

const DOMAIN_NAME = {
	// ip:端口号
	URL_EASYMOCK: 'https://sqzs.aizhishifm.cn/server/', // 线上
	// URL_EASYMOCK: 'http://192.168.1.101:8881', // 线上
	// URL_EASYMOCK: 'http://192.168.1.109:8881', // 测试http://192.168.2.115:8123
	channelId: 1,
}
export default DOMAIN_NAME
